<template>
  <div class="h100-full overflow-y">
    <div v-if="zdGoodsDyDtlList && zdGoodsDyDtlList.length > 0">
      <div class="f18_rem fb gray_2 pad20-lr pad5-tb">精选答疑({{ zdGoodsDyDtlList.length }})</div>
      <div class="pad20-lr bg-white border-tb mar15-b" v-for="item in zdGoodsDyDtlList">
        <div class="flex pad5-t pad10-b q">
          <div class="flex-auto fb f16 gray3 mar10-r question" style="word-break:break-all">
            {{ item.question }}
          </div>
          <div v-if="item.personAmount" class="flex-shrink">{{ item.personAmount }}人同问</div>
        </div>
        <div class="f13 pad10-b" style="word-break:break-all">商家回复：{{ item.answer }}</div>
      </div>
    </div>

    <div v-if="qtGoodsDyDtlList && qtGoodsDyDtlList.length > 0">
      <div class="f18_rem fb gray_2 pad20-lr pad10-t pad5-b">
        其他答疑({{ qtGoodsDyDtlList.length }})
      </div>
      <div class="pad20-lr bg-white border-tb mar15-b" v-for="item in qtGoodsDyDtlList">
        <div class="flex pad5-t pad10-b q">
          <div class="flex-auto fb f16 gray3 mar10-r question" style="word-break:break-all">
            {{ item.question }}
          </div>
          <div v-if="item.personAmount" class="flex-shrink">{{ item.personAmount }}人同问</div>
        </div>
        <div class="f13 pad10-b" style="word-break:break-all">商家回复：{{ item.answer }}</div>
      </div>
    </div>

    <div class="text-center pad10-tb f12 gray9">
      已加载全部答疑，更多请
      <div class="blue" @click="contactService">联系客服</div>
    </div>
    <div class="pad30-tb"></div>
  </div>
</template>

<style lang="scss" scoped>
@import "./qa.scss";
</style>
<script>
import { contactService } from "@/utils/utils";

export default {
  name: "qa",
  data() {
    return {
      skuId: "",
      goodsDyDtlList: [],
      zdGoodsDyDtlList: [],
      qtGoodsDyDtlList: [],
      detail: {}
    };
  },
  watch: {},
  created() {
    this.skuId = this.$route.query.skuId;
    this.getGoodsDetail();
  },

  methods: {
    contactService() {
      contactService();
    },
    getGoodsDetail() {
      console.log("skuId", this.skuId);
      const param = {
        goodsId: this.skuId
      };
      this.$store
        .dispatch("goodDetails/goodDetails/detail", this.$qs.stringify(param))
        .then(data => {
          if (data.code != "0") {
            return;
          }
          this.detail = data.data || {};
          this.goodsDyDtlList = this.detail.goodsDyDtlList || [];
          this.zdGoodsDyDtlList = this.goodsDyDtlList.filter(item => item.top == true);
          this.qtGoodsDyDtlList = this.goodsDyDtlList.filter(item => item.top == false);
        });
    }
  }
};
</script>
